import { formatDate } from 'helpers/datesHelper.js';
const today = new Date();

export default (requests) => {
  return {
    getTransactionsByFilter: ({
      activeTab = 'all',
      endDate = today,
      startDate = today,
      limit = 10,
      currentPage = 0,
      activeFilter = 'all',
    } = {}) => {
      const offset = currentPage * limit;
      const dateFrom = formatDate(startDate, 'yyyy-MM-dd');
      const dateTo = formatDate(endDate, 'yyyy-MM-dd');
      return requests.get(
        `/transaction/transactions/${dateFrom}/${dateTo}/${limit + 1}/${offset}/${activeTab}${
          activeFilter != 'all' ? `?eventsSlipType=${activeFilter}` : ''
        }`
      );
    },
    getCashouts: ({ endDate = today, startDate = today } = {}) => {
      const dateFrom = formatDate(startDate, 'yyyy-MM-dd');
      const dateTo = formatDate(endDate, 'yyyy-MM-dd');
      return requests.get(`/cashout/bets/${dateFrom}/${dateTo}/`);
    },
    getMultiCashouts: (betSlipsIds = []) => {
      return requests.get(`/cashout/multi/maxAmount/${betSlipsIds.join(',')}`);
    },
    cashoutMaximumAmount: (slipId, combinationId = null) => {
      return requests.get(`/cashout/max/${slipId}${combinationId ? `?combinationId=${combinationId}` : ''}`);
    },
    cashoutPartialAmount: (slipId, data, combinationId = null) => {
      return requests.post(`/cashout/partial/${slipId}${combinationId ? `?combinationId=${combinationId}` : ''}`, data);
    },
    cashoutFullAmount: (slipId, data, combinationId = null) => {
      return requests.post(`/cashout/full/${slipId}${combinationId ? `?combinationId=${combinationId}` : ''}`, data);
    },
    cashoutPrepareLiveCountDown: (slipId, data) => {
      return requests.post(`/cashout/prepare-live-countdown/${slipId}`, data);
    },
  };
};
